import { processMenu } from "@/_core/data/api_calls/menu/processMenu";
import { gatewayService } from "@/_services/gateway.service";

/**
 * Fetches the menu configuration for currencies.
 *
 * @param {object} ctx - Context containing user and currency information.
 * @returns {Promise} - Returns a promise resolving to the processed menu data.
 */
export function getMenuCurrencies(ctx) {
  const variables = {
    format: "json",
    currency: ctx.currencyNumber,
    user: ctx.user.pk_idusers
  };
  return processMenu(ctx, {
    fetch: gatewayService.catalogs.menu,
    variables
  });
}
